import React from 'react';
import Cookies from 'js-cookie';
import styled from 'styled-components';
import { Alert } from '@zopauk/react-components';

interface PreReleaseDisclaimerProps extends PreReleaseDisclaimerStyleProps {
  enabled: boolean;
}

interface PreReleaseDisclaimerStyleProps {
  navbarHeight?: number;
}

const DisclaimerContent = styled.div<PreReleaseDisclaimerStyleProps>`
  z-index: 3; /* Stay above the modal */
  position: sticky;
  top: ${({ navbarHeight }) => `${navbarHeight}px`};
`;

/**
 * Show a pre-release disclaimer on top of the page. Can be overriden by setting a cookie disablePreReleaseDisclaimer to "1".
 * @param enabled Set to true to show the disclaimer. Defaults to false.
 * @param navbarHeight Use this prop to place the disclaimer below the navbar if the navbar is sticky. Sets the CSS top value. Defaults to 0.
 */
export const PreReleaseDisclaimer = ({ navbarHeight = 0, enabled = false }: PreReleaseDisclaimerProps) => {
  const disabledByCookie = Cookies.get('disablePreReleaseDisclaimer') === '1';

  if (disabledByCookie) {
    return null;
  }

  if (enabled === true) {
    return (
      <DisclaimerContent navbarHeight={navbarHeight}>
        <Alert severity="warning">
          Private pre-release version intended for testing purposes only. Do not fill in any personal details.
        </Alert>
      </DisclaimerContent>
    );
  }

  return null;
};
